module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/ogp-cbae8607c912c7eb7ef6db890e03966e.png";